import { ViewPointUI as ViewPointUIV1 } from "./ViewPoint/v1";
import { withVersions } from "v2/hocs/withVersions";

const ViewPoint = {
  Custom: withVersions({
    v1: ViewPointUIV1,
    v2: ViewPointUIV1,
  }),
  Mobile: withVersions({
    v1: ViewPointUIV1.Mobile,
    v2: ViewPointUIV1.Mobile,
  }),
  Desktop: withVersions({
    v1: ViewPointUIV1.Desktop,
    v2: ViewPointUIV1.Desktop,
  }),
};

export { ViewPoint };
